import template from './pets-allowed.jade';
import itemsYesNo from '../../../enums/yes-no';

export default angular
    .module('cian.addForm.petsAllowed', ['cian.addForm.fieldTypeSwitcher'])
    .directive('cianAfAboutObjectPetsAllowed', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
        },
        controller() {
            this.items = itemsYesNo;
            if (!this.ad.petsAllowed && this.ad.category === 'roomRent' && this.items[1]) {
                this.ad.petsAllowed = this.items[1].value;
            }
        },
        controllerAs: 'petsAllowedCtrl',
        template,
    }))
    .name;
